/**
 * SiteUp: dinheiro em PT-BR.
 *
 * Existiam duas formas erradas espalhadas: `toFixed(2)` (que devolve ponto
 * decimal, "R$ 0.00") e o valor cru do banco (`{{ offer.value }}`, que mostrava
 * "R$ 90.0"). Nenhuma das duas é como se escreve dinheiro em português.
 */

const FORMATOS = {};

const formatador = moeda => {
  if (!FORMATOS[moeda]) {
    FORMATOS[moeda] = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: moeda,
    });
  }
  return FORMATOS[moeda];
};

/**
 * @param {number|string} valor valor na unidade principal (reais, não centavos)
 * @param {string} [moeda='BRL']
 * @returns {string} ex.: "R$ 1.195,20"
 */
export const formatarMoeda = (valor, moeda = 'BRL') => {
  // `Number(null)` e `Number('')` são 0, e 0 é um valor legítimo: sem esta
  // guarda, "sem valor" virava "R$ 0,00" — que é uma afirmação diferente.
  if (valor === null || valor === undefined || valor === '') return '';
  const n = Number(valor);
  if (!Number.isFinite(n)) return '';
  try {
    return formatador(moeda).format(n);
  } catch (e) {
    // Moeda desconhecida vinda da API: melhor mostrar o número certo com o
    // código ao lado do que quebrar a linha inteira da tabela.
    return `${moeda} ${n.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
};

/** Mesma coisa para valores que a API manda em CENTAVOS (VoIP). */
export const formatarCentavos = (centavos, moeda = 'BRL') =>
  formatarMoeda((Number(centavos) || 0) / 100, moeda);
